
export const home = {
  title: '首页',
  path: '/home',
  name: 'home',
  component: () => import('@/view/home/home.vue'),
  children: []
}
export const login = {
  title: '登录',
  path: '/',
  name: 'login',
  component: () => import('@/view/login/login.vue')
}
export const loginto = {
  title: '登录',
  path: '/login',
  name: 'login',
  component: () => import('@/view/login/login.vue')
}
export const appRouter = []
export const routers = [
  login,
  loginto,
  home,
  ...appRouter
]



// WEBPACK FOOTER //
// ./src/router/router.js